





























import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import AppRelease from '@/modules/app-router/model/AppRelease';
import ApiVersionSelect from '@/modules/app-router/components/ApiVersion/ApiVersionSelect.vue';
import ApiVersion from '@/modules/app-router/model/ApiVersion';
import {DuplicateOptions} from '@/modules/app-router/api';
import {VForm} from '@/types';
import {Colors, notify} from '@/modules/core/notification';

/**
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ApiVersionSelect},
})
export default class DuplicateRelease extends Vue {
    public $refs: Vue['$refs'] & {
        form: VForm
        versionInput: any,
    }
    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Distribución actualmente seleccionada por el usuario
     */
    @State(state => state.appRouter.release)
    public release: AppRelease

    @Action('appRouter/duplicateRelease')
    public duplicateAppRelease: (options: DuplicateOptions) => Promise<AppRelease>

    public duplicating = false
    public version = ''
    public api: ApiVersion | null = null

    public rules = {
        version: [
            (v: string) => !!v || 'El número de versión es obligatorio',
            (v: string) => /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(-(0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(\.(0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*)?(\+[0-9a-zA-Z-]+(\.[0-9a-zA-Z-]+)*)?$/.test(v)
                || 'El número de versión no es válido',
        ],
    }

    @Watch('release')
    public watchRelease (release: AppRelease) {
        this.api = this.release ? this.release.apiVersion : null
        this.$nextTick( () => this.$refs.form && this.$refs.form.resetValidation())
    }

    /**
     * Solicita a la aplicación la duplicación de la distribución seleccionada
     * por el usuario
     */
    public async duplicate () {
        if (!this.$refs.form.validate()) {
            return
        }

        this.duplicating = true

        await this.duplicateAppRelease({
            version: this.version,
            apiVersion: this.api ? this.api.id : 0,
        })

        this.$emit('input', false)
        this.duplicating = false

        notify(`La distribución ${this.release.version} ha sido duplicada correctamente`)
    }

    public errorCaptured (error: Error) {
        this.duplicating = false
        notify(error.message, Colors.Error)
    }
}
